<template>
  <div>
    <b-card style="background-color: transparent" border-variant="light">
      <div v-if="!typingSingleFetching && lessonList && lessonList.length">
        <b-container class="bv-example-row">
          <b-row>
            <b-col v-for="(lessons, index) in lessonList" :key="index" lg="3" md="6" sm="12" class="eachCard">
              <TypingSingleLessonCard :lessons="lessons" />
            </b-col>
          </b-row>
        </b-container>
        <!-- <b-card-footer>
          <b-progress striped animated :max="100" height="2rem">
            <b-progress-bar :value="completeRate">
              <strong>{{ completeRate }}%</strong>
            </b-progress-bar>
          </b-progress>
        </b-card-footer> -->
      </div>
      <div v-else>
        <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
      </div>
    </b-card>
  </div>
</template>

<script lang='js'>
import Vue from 'vue'
import { mapState } from 'vuex'
import TypingSingleLessonCard from '@/components/Typing/TypingSingle/TypingSingleLessonCard.vue'
// import { roundDecimal } from '@/util/math'

const TypingSingleLessonList = Vue.extend({
  name: 'TypingSingleLessonList',
  components: {
    TypingSingleLessonCard
  },
  mounted () {
    this.$store.dispatch('typing/fetchTypingSingleLessonLists')
      .then((response) => {
        if (response === 'OK') {
          this.preprocess()
        }
      })
  },
  computed: {
    ...mapState({
      typingSingleFetching: state => state.typing.typingSingleFetching,
      typingSingleLessonList: state => state.typing.typingSingleLessonList
    }),
    currentUser () {
      return this.$store.state.auth.currentUser
    }
  },
  data () {
    return {
      lessonList: [],
      completeRate: 0
    }
  },
  methods: {
    preprocess () {
      const advancedList = [3, 6, 9, 12, 15, 16]
      const userGradeCode = Number(this.currentUser.gradeId)
      let combinedList = []
      let toShowRule = false
      // let completedCount = 0
      for (let i = 0; i < this.typingSingleLessonList.singleBasicLessons.length; i++) {
        if (userGradeCode === 1 || userGradeCode === 18) {
          this.typingSingleLessonList.singleBasicLessons[i].showDescription = true
          this.typingSingleLessonList.singleIntermediateLessons[i].showDescription = true
          this.typingSingleLessonList.singleAdvancedLessons[i].showDescription = true
          combinedList.push([
            this.typingSingleLessonList.singleBasicLessons[i],
            this.typingSingleLessonList.singleIntermediateLessons[i],
            this.typingSingleLessonList.singleAdvancedLessons[i]
          ])
          continue
        }

        if (userGradeCode > 3 && userGradeCode !== 19 && !advancedList.includes(this.typingSingleLessonList.singleBasicLessons[i].lesson_id)) {
          continue
        }

        this.typingSingleLessonList.singleBasicLessons[i].showDescription = false
        if (!toShowRule) {
          if (!this.typingSingleLessonList.singleBasicLessons[i].locked && this.typingSingleLessonList.singleIntermediateLessons[i].locked) {
            this.typingSingleLessonList.singleBasicLessons[i].showDescription = true
            toShowRule = true
          } else if (!this.typingSingleLessonList.singleIntermediateLessons[i].locked && this.typingSingleLessonList.singleAdvancedLessons[i].locked) {
            this.typingSingleLessonList.singleIntermediateLessons[i].showDescription = true
            toShowRule = true
          } else if (i + 1 < this.typingSingleLessonList.singleBasicLessons.length &&
          !this.typingSingleLessonList.singleAdvancedLessons[i].locked && this.typingSingleLessonList.singleBasicLessons[i + 1].locked) {
            this.typingSingleLessonList.singleAdvancedLessons[i].showDescription = true
            toShowRule = true
          }
        }

        combinedList.push([
          this.typingSingleLessonList.singleBasicLessons[i],
          this.typingSingleLessonList.singleIntermediateLessons[i],
          this.typingSingleLessonList.singleAdvancedLessons[i]
        ])
      }
      this.lessonList = combinedList

      // roundDecimal((completed / (this.combinedList.length * 3)) * 100, 2)
    }
  }
})

export default TypingSingleLessonList
</script>

<style lang='scss' scoped>
@import '../styles/lessonCardStyles.scss';
</style>
